import React from "react";

function ContactNL() {
  return <div>Contact</div>;
}

export default ContactNL;
